var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tr-radio",attrs:{"checked":_vm.model === _vm.value}},[_c('input',_vm._b({ref:"input",staticClass:"tr-radio__input",attrs:{"type":"radio"},domProps:{"value":_vm.value},on:{"change":function($event){$event.target.checked && _vm.$emit('change', _vm.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"tr-radio__checkmark"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635e1890","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TRRadio.vue
// module id = null
// module chunks = 